<template>
    <BaseUiSwiper class="speciallist-items" :options="sliderOptions">
        <BaseUiSwiperSlide v-for="item in items" :key="item.id">
            <CatalogIndexEntry :item="item" mode="slider" />
        </BaseUiSwiperSlide>
    </BaseUiSwiper>
</template>

<script setup>
	const props = defineProps(['items', 'perPage']);
    const {mobileSmallBreakpoint} = inject('rwd');

	const sliderOptions = {
		slidesPerView: mobileSmallBreakpoint.value ? 2 : (props.perPage ? props.perPage : 4),
		slidesPerGroup: mobileSmallBreakpoint.value ? 2 : (props.perPage ? props.perPage : 4),
		navigation: {enabled: true},
		watchSlidesProgress: false,
		spaceBetween: -1,
		enabled: false,
		breakpoints: {
			760: {
				enabled: true,
			}
		}        
	}   
</script>

<style lang="less" scoped>
	.speciallist-items{position: relative; display: block;}

    :deep(.cp){
        width: 100%; margin: 0;
        @media (max-width: @m){
            height: 100%;
            .cp-image{
                a{height: 250px;}
            }
            .cp-badges-container{flex-flow: column;}
            .cp-badge-special-attr{font-size: 12px; line-height: 16px; padding: 4px 8px;}
            .cp-badge-discount{font-weight: normal;}
            .cp-brand{font-size: 14px; font-weight: bold;}
            .cp-title{font-size: 16px; line-height: 19px; padding-bottom: 6px;}
            .cp-current-price, .cp-discount-price{font-size: 16px;}
            .cp-extra-price-lowest-empty{height: auto;}
            .cp-qty-add{gap: 8px;}
            .cp-price{padding-bottom: 18px;}
            .cp-btn-addtocart{
                height: 44px; width: auto; font-size: 16px !important; padding: 0 20px;
            	span{
                    width: auto; height: auto; padding-left: 30px;
                    &:before{top: 1px;}
                }
            }
            .cp-qty{
                width: 96px;
                input{height: 44px; font-size: 16px;}
                .qty-btn{height: 44px;}
            }
            .cp-unit-desc{font-size: 13px;}
            .cp-extra-price-lowest{font-size: 13px; max-width: none;}
        }
    }


    :deep(.swiper-wrapper){
        @media (max-width: @m){
            display: flex; position: relative; padding: 1px 16px 0; width: 100%; box-sizing: border-box; overflow-x: auto;
            &::-webkit-scrollbar {-webkit-appearance: none; height: 0;}
            &::-webkit-scrollbar-thumb {background-color: transparent;}
        }
    }        
    :deep(.swiper-slide){
        display: flex; height: auto;
        &:hover{z-index: 1; }
        @media (max-width: @m){display: block; width: 278px!important; flex-grow: 0; flex-shrink: 0; opacity: 1; visibility: visible;}
    }
	:deep(.swiper-navigation){
		display: flex; justify-content: space-between; position: absolute; top: 30%; left: -90px; right: -90px; height: 50px; 
		@media (max-width: @l){left: 16px; right: 16px;}
		@media (max-width: @t){left: -28px; right: -28px; height: 32px; top: calc(~"50% - 16px");}
		@media (max-width: @m){left: 5px; right: 5px; height: 30px; top: 80px;}
	}
    :deep(.swiper-button){
        aspect-ratio: 1; display: flex; align-items: center; justify-content: center; font-size: 0; cursor: pointer; 
        @media (min-width: @h){
            &:hover{
                &:before{color: #472266;}
            }
        }
        &:before{
            .icon-arrow-left; font: 30px/30px var(--fonti); z-index: 60; color: var(--primaryColor);
            @media (max-width: @t){font-size: 20px; line-height: 20px}
        }
        &.swiper-button-disabled{opacity: 0.2; cursor: default;}
        &.swiper-button-lock{display: none;}
    }
    :deep(.swiper-button-next){
        &:before{transform: rotate(180deg);}
    }

</style>